import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';

import { getAccessToken } from '../utils/auth.util';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private jwtHelper = new JwtHelperService();

  constructor(private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const token = getAccessToken();
    if (!token || this.jwtHelper.isTokenExpired(token)) {
      return this.router.parseUrl('/landing');
    } else {
      return true;
    }
  }
}
